import React from 'react';
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axiosClient from "../axios-client.js";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import swal from 'sweetalert';

const Perfil = () => {
  const [perfil, setPerfil] = useState({});
  // NUEVOS ESTADOS PARA EDICIÓN
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const [packageHistory, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingHist, setLoadingHist] = useState(false);
  const [loadingTokens, setLoadingTokens] = useState(false);
  const [loadingPostToken, setLoaginPostToken] = useState(false);
  const [packageTokens, setPackageTokens] = useState([]);
  const [show, setShow] = useState(false);
  const tokenRef = useRef();
  const [errorReset, setResetErrors] = useState(null);
  
  const userData = JSON.parse(localStorage.getItem('USER_DATA'));
  const urlParams = new URLSearchParams(window.location.search);
  const newPackage = urlParams.get('nuevoPaquete');

  useEffect(() => {
    getPerfil();
    getTokens();
    getHistory();
    if (newPackage) {
      swal({
        title: "Paquete abonado",
        text: "Ya puedes reservar clases en tu horario preferido.",
        icon: "success",
      });
    }
  }, []);

  const getPerfil = () => {
    setLoading(true);
    axiosClient.get('/perfil')
      .then(({ data }) => {
        setLoading(false);
        setPerfil(data);
        // Inicializamos el formulario con los datos recibidos
        setFormData({
          name: data.name || '',
          email: data.email || '',
          phone: data.phone || ''
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // MANEJADORES DE EDICIÓN
  const handleEditChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const updatePerfil = () => {
    setLoadingUpdate(true);
    axiosClient.put('/users/'+perfil.id, formData)
      .then(({ data }) => {
        setLoadingUpdate(false);
        setIsEditing(false);
        setPerfil(formData); // Actualizamos la vista
        swal("¡Actualizado!", "Tu perfil ha sido actualizado correctamente", "success");
      })
      .catch((err) => {
        setLoadingUpdate(false);
        const response = err.response;
        if (response && response.status === 422) {
          swal("Error", "Revisa los datos ingresados", "error");
        }
      });
  };

  const validatePerfil = () => {
    // Validaciones básicas
    if (!formData.name || !formData.email || !formData.phone) { 
      swal("Error", "Todos los campos son obligatorios", "error");
      return;
    }
    // Validación de formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      swal("Error", "El formato del email es inválido", "error"); 
      return;
    }
    // Validación de formato de teléfono
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(formData.phone)) {
      swal("Error", "El formato del teléfono es inválido. Debe contener 10 dígitos numéricos.", "error");
      return;
    }
    // Si todo es válido, actualizamos el perfil
    updatePerfil();
  }

  const getTokens = () => {
    setLoadingTokens(true);
    const user = JSON.parse(localStorage.getItem('USER_DATA'));
    axiosClient.get('/package-tokens/' + user.id)
      .then(({ data }) => {
        setLoadingTokens(false);
        setPackageTokens(data.data);
      })
      .catch(() => {
        setLoadingTokens(false);
      });
  };

  const getHistory = () => {
    setLoadingHist(true);
    const user = JSON.parse(localStorage.getItem('USER_DATA'));
    axiosClient.get('/package-history/user/' + user.id)
      .then(({ data }) => {
        setLoadingHist(false);
        setHistory(data.data);
      })
      .catch(() => {
        setLoadingHist(false);
      });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const saveToken = (token) => {
    setLoaginPostToken(true);
    if (!token.current.value) {
      setResetErrors("Favor de ingresar un token");
      setLoaginPostToken(false);
      return;
    }
    const user = JSON.parse(localStorage.getItem('USER_DATA'));
    const payload = {
      status: "Pendiente",
      user_id: user.id,
      token: token.current.value
    };
    axiosClient.post('/package-tokens', payload)
      .then(({ data }) => {
        setLoaginPostToken(false);
        swal({
          title: "Token abonado",
          text: "En cuanto sea validado el token, este será agregado a tu paquete.",
          icon: "success",
        });
        handleClose();
        getTokens();
      })
      .catch(() => {
        setLoaginPostToken(false);
      });
  };

  const cleanReset = () => setResetErrors("");

  return (
    <div className='container'>
      {loading ? (
        <div className='loading-container center'>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      ) : (
        <div className='datos-container'>
          <div className='d-flex justify-content-between align-items-center'>
            <p className='semi-bold'>Datos Personales</p>
            {!isEditing ? (
              <Button variant="outline-primary" size="sm" onClick={() => setIsEditing(true)}>
                Editar Perfil
              </Button>
            ) : (
              <div>
                <Button variant="success" size="sm" className="me-2" onClick={validatePerfil} disabled={loadingUpdate}>
                  {loadingUpdate ? 'Guardando...' : 'Guardar'}
                </Button>
                <Button variant="secondary" size="sm" onClick={() => { setIsEditing(false); setFormData(perfil); }}>
                  Cancelar
                </Button>
              </div>
            )}
          </div>
          <hr />
          
          <div className='datos-text mb-3'>
            <span className='semi-bold m-2'>Nombre:</span>
            {isEditing ? (
              <input type="text" name="name" className="form-control d-inline w-50" value={formData.name} onChange={handleEditChange} />
            ) : (
              perfil.name
            )}
          </div>

          <div className='datos-text mb-3'>
            <span className='semi-bold m-2'>Email:</span>
            {isEditing ? (
              <input type="email" name="email" className="form-control d-inline w-50" value={formData.email} onChange={handleEditChange} />
            ) : (
              perfil.email
            )}
          </div>

          <div className='datos-text mb-3'>
            <span className='semi-bold m-2'>Celular:</span>
            {isEditing ? (
              <input type="text" name="phone" className="form-control d-inline w-50" value={formData.phone} onChange={handleEditChange} />
            ) : (
              perfil.phone
            )}
          </div>
        </div>
      )}

      {loadingHist ? (
        <div className='loading-container center'>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      ) : (
        <div className='datos-container mt-4'>
          <p className='semi-bold'>Historial de Paquetes</p>
          <hr></hr>
          {!packageHistory || packageHistory.length === 0 ? (
            <p>No tienes historial disponible</p>
          ) : (
            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>Fecha Compra</th>
                    <th>Fecha Expiración</th>
                    <th>Clases Compradas</th>
                    <th>Clases Usadas</th>
                    <th>Clases Disponibles</th>
                    <th>Estatus</th>
                  </tr>
                </thead>
                <tbody>
                  {packageHistory.map((data) => (
                    <tr key={data.id}>
                      <td>{data.transaction_date}</td>
                      <td>{data.expiration_date}</td>
                      <td>{data.total_classes}</td>
                      <td>{data.used_classes}</td>
                      <td>{data.available_classes}</td>
                      <td>{data.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Modal de Tokens se mantiene igual */}
      <Modal className="modal fade" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Registro de Token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Ingresa tu token de Total Pass.</p>
          <input className="w-100 mb-3 mt-2 form-control" ref={tokenRef} type="text" placeholder="Token" onChange={cleanReset}/>
          {errorReset && <p className="text-danger">{errorReset}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => saveToken(tokenRef)} disabled={loadingPostToken}>
            Agregar
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Perfil;